export enum TreeGridColumnType {
  Text = 'text',
  Date = 'date'
}
